<template>
  <div>
    <b-modal
      size="md"
      centered
      ok-title="Enviar"
      id="modal-email-authentication"
      modal
      :title="$ml.get('informPassword')"
      @hide="closeModalView"
    >
      <div class="login">
        <div v-show="actionType === 'archivedProgram' && statusProgram === 'archived'"  class="alert alert-warning text-center text-font-14">
          <span v-text="$ml.get('alertReactivateProgram')">Desativar programa</span>
        </div>
        <div v-show="actionType === 'archivedProgram' && statusProgram != 'archived'"  class="alert alert-warning text-center text-font-14">
          <span v-text="$ml.get('alertArchivedProgram')">Arquivar programa</span>
        </div>
        <p class="label-confirm">
          {{ $ml.get('confirmPasswordLabel') }}
        </p>
        <div class="form-group" style="position: relative">
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            v-model.trim="password"
            name="password"
            placeholder="********"
            maxlength="50"
          />
          <VueCustomTooltip
            :label="$ml.get(showPassword ? 'unshowPassword' : 'showPassword')"
            class="login-ico visible-password"
            style="position: absolute"
          >
            <svg class="ico-20" @click="showPassword = !showPassword">
              <image
                v-show="showPassword"
                xlink:href="../../assets/icons/eye-slash.svg"
                width="20"
                height="20"
              />
              <image
                v-show="!showPassword"
                xlink:href="../../assets/icons/eye.svg"
                width="20"
                height="20"
              />
            </svg>
          </VueCustomTooltip>
          <transition name="fade">
            <label v-if="errorPassword" class="lblError">
              {{ $ml.get('invalidPassword') }}
            </label>
          </transition>
        </div>
      </div>
      <template #modal-footer="{ ok }">
        <b-button
          style="background: #730ba9; min-width: 90px"
          :disabled="!password"
          size="sm"
          @click="performFunction(actionType, ok)"
        >
          <span>{{ $ml.get('confirmBtn') }}</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import CompanyService from '../../services/company.service.js';
import HackerService from '../../services/hacker.service.js';
import programService from '../../services/program.service';
import Swal from 'sweetalert2';
export default {
  name: 'PasswordConfirmationActivationModal',
  props: ['twoFactoryAuthentication', 'actionType', 'statusProgram'],
  data() {
    return {
      password: '',
      showPassword: false,
      errorPassword: false,
      userType: '',
    };
  },

  watch: {
    password() {
      this.errorPassword = false;
    },
  },
  mounted() {
    this.programId = this.$route.fullPath.split('?')[1];
    this.userType = this.$store.getters['getUser'].type;
  },
  methods: {
    performFunction(action, ok){
      switch(action){
        case '2fa':
        this.updateCompany2fa(ok)
        break;
        case '2fa_hacker':
        this.updateHacker2fa(ok)
        break;
        case 'archivedProgram':
        this.archiveProgram(ok);
        break;
        case 'codeEmail':
        this.enableHackerEmailAuthentication(ok);
        break;
        default:
          if(this.userType === 'company')
          this.enableEmailAuthentication(ok);
        break;
        
      }
    },
    async archiveProgram(closeModal){
     try {
      const response = await programService.postArchiveProgram(this.programId, {
      password: this.password
     })
     if(response.data === 'program status is now archived'){
        Swal.fire({
            icon: 'success',
            title: "Programa arquivado!",
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
      }
      if(response.data === 'program status is now unarchived'){
        Swal.fire({
            icon: 'success',
            title: "Programa reativado!",
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
      }
      this.$emit('getProgram');
      closeModal()
     } catch (error) {
        console.log(error.response);
       if(error.response.data.message === "O usuário não possui permissão para executar esta ação!"){
        this.errorPassword = true;
        return;
       }
     }
    },
    async enableEmailAuthentication(ok) {
      this.errorPassword = false;

      try {
        const { status } = await CompanyService.putEmailAuthentication({
          password: this.password,
        });
        if (status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.$ml.get('configSuccess'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          this.password = '';
          ok();
          this.$emit('update');
        }
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          this.errorPassword = true;
          return;
        }
        this.password = '';
      }
    },
    async enableHackerEmailAuthentication(ok) {
      this.errorPassword = false;

      try {
        const { status } = await HackerService.putHackerEmailAuthentication({
          password: this.password,
        });
        if (status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.$ml.get('configSuccess'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          this.password = '';
          ok();
          this.$emit('updateEmailAuthentication');
        }
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          this.errorPassword = true;
          return;
        }
        this.password = '';
      }
    },
    async updateCompany2fa(ok) {
      this.errorPassword = false;
      try {
        const { status } = await CompanyService.putCompany2fa({
          active: !this.twoFactoryAuthentication,
          password: this.password,
        });
        if (status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.$ml.get('configSuccess'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          this.password = '';
          ok();
          this.$emit('update');
        }
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          this.errorPassword = true;
          return;
        }
        if (error.response.data.statusCode === 400) {
          Swal.fire({
            icon: 'warning',
            title: this.$ml.get('warningTwoFactorAuthentication'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
          });
          return;
        }
        this.password = '';
      }
    },
    async updateHacker2fa(ok) {
      this.errorPassword = false;
      try {
        const { status } = await CompanyService.puthHacker2fa(this.programId, {
          active: !this.twoFactoryAuthentication,
          password: this.password,
        });
        if (status === 200) {
          Swal.fire({
            icon: 'success',
            title: this.$ml.get('configSuccess'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          this.password = '';
          this.$emit('getProgram');
          ok();
        }
      } catch (error) {
        if (error.response.data.statusCode === 403) {
          this.errorPassword = true;
          return;
        }
        if (error.response.data.statusCode === 400) {
          Swal.fire({
            icon: 'warning',
            title: this.$ml.get('warningTwoFactorAuthentication'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 5000,
          });
          return;
        }
        this.password = '';
      }
    },
    closeModalView() {
      this.password = '';
      this.$emit('closeModal')
    },
  },
};
</script>
<style scoped>
.visible-password {
  top: 0px;
  right: 5px;
  transform: translate(-50%, 50%);
}
.label-confirm {
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.3;
}
.label-confirm span {
  text-decoration: underline;
}
.text-font-14{
  font-size:14px;
}
</style>
